import { App } from 'antd';
import { useEffect } from 'react';

import { setAntdMessageApi } from './antdAppBridge';

export default function AntdAppInit() {
  const { message } = App.useApp();

  useEffect(() => {
    setAntdMessageApi(message);

    return () => {
      setAntdMessageApi(null);
    };
  }, [message]);

  return null;
}
